import React from 'react'
import CarouselImages from './CarouselImages'
import ContactUsForm from './ContactUsForm'
import Cards from './Cards'
import FooterMain from './FooterMain'

export default function Dashboard() {
  return (
    <div>
        
        {/* <h2>Hello everyone !! THIS IS A DASHBOARD</h2> */}

        <CarouselImages/>

        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        
        {/* <div style={{display : 'flex' , justifyContent : 'center' }} >

        <Card1/>
        <Card2/>
        <Card3/>
        <Card4/>


        </div>
         */}
         <Cards/>

         <br />
         <br />
         <div style={{backgroundColor : '#414040'}} >
         <p style={{fontSize : '40px' , marginLeft : '300px'}} >GET IN TOUCH WITH US</p>

      <div style={{display : 'flex' , justifyContent : 'center' }} >

<img src="https://make4thon.mlsctiet.co.in/email-conta.png" style={{width : '500px' , height : '500px' , marginRight : '200px' }} alt="" />

          <ContactUsForm  />
      </div>

      </div>

      <br />
      <br />
        

        <br />
        <br />

    </div>
  )
}
